export default "__VITE_PUBLIC_ASSET__13e944dd__"